import CheckSVG from "@design-system/ui-icons/vanilla/Check"
import { createIcon } from "../createIcon"

export const CheckIcon = createIcon(CheckSVG)
